import { render, staticRenderFns } from "./PkOrderDetail.vue?vue&type=template&id=53d44ee6&scoped=true"
import script from "./PkOrderDetail.vue?vue&type=script&lang=js"
export * from "./PkOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PkOrderDetail.vue?vue&type=style&index=0&id=53d44ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d44ee6",
  null
  
)

export default component.exports